import React, { useState } from 'react';
import EmojiButton from '../../atoms/EmojiButton';
import stl from './EmojiSelector.module.css';
import SvgLikeIcon from "../../assets/icons/SvgLikeIcon";
import SvgDislikeIcon from "../../assets/icons/SvgDislikeIcon";
import SvgAmazingIcon from "../../assets/icons/SvgAmazingIcon";

const emojis = [<SvgDislikeIcon/>, <SvgLikeIcon/>,  <SvgAmazingIcon/>];

const EmojiSelector = ({onClick, initialEmojiIndex}) => {
    const [selectedEmoji, setSelectedEmoji] = useState(emojis[initialEmojiIndex] || null);
    const handleSelect = (amount, index) => {
        setSelectedEmoji(amount);
        if (onClick) {
            onClick(index);
        }
    };
    return (
        <div className={stl.container}>
            {emojis.map((emoji, index) => (
                <EmojiButton
                    key={index}
                    emoji={emoji}
                    isSelected={selectedEmoji === emoji}
                    onClick={() => handleSelect(emoji, index)}
                />
            ))}
        </div>
    );
};

export default EmojiSelector;
